import { CampaignRemainingComponent } from './campaign-remaining.component';

export default angular
  .module('sfMobile.components.campaign-remaining', [])
  .component('sfCampaignRemaining', CampaignRemainingComponent).name;
